<div class="survey">
  <div class="survey__field" *ngFor="let field of fields$ | async; let index = index; trackBy: trackBy">
    <app-survey-field
      [field]="field"
      [value]="field | defaultValue: date:slug:'REPORT' | async"
      [index]="index"
      [error]="(errors$ | async)[field.id]"
      [symbol]="field.dataDefinitionId | getSymbol | async"
      (handleHelp)="handleHelp($event)"
      (handleChange)="handleFieldResponse($event)"
    ></app-survey-field>
  </div>
</div>
